<template>
    <span class="error error--validation is-danger font-size-small">
        {{ message || '' }}
    </span>
</template>

<script>
    export default {
        name: 'InputError',
        props: {
            message: {
                default: '',
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "@/assets/scss/_variables.scss";

    .error {
        color: $red;
        margin-top: -10px;
        display: block;
        padding: 0.2em 0;
        word-wrap: break-word;
        white-space: nowrap;
        overflow: hidden;
    }
</style>
